// ./undoIcon.tsx
const UndoIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21,24H3V20.591A11.945,11.945,0,0,1,6.987,12,11.938,11.938,0,0,1,3,3.409,3.412,3.412,0,0,1,6.409,0H17.591A3.413,3.413,0,0,1,21,3.409,11.963,11.963,0,0,1,17.028,12,11.963,11.963,0,0,1,21,20.591ZM6,21H18v-.409c0-3.384-2.271-5.9-4.177-7.417L12.347,12l1.476-1.174C15.729,9.311,18,6.793,18,3.409A.41.41,0,0,0,17.591,3H6.409A.41.41,0,0,0,6,3.409c0,3.386,2.281,5.9,4.2,7.414L11.682,12,10.2,13.176C8.282,14.691,6,17.207,6,20.591Zm6.012-6.711.566.45A9.143,9.143,0,0,1,15.763,19H8.239a9.142,9.142,0,0,1,3.2-4.255l.576-.456" />
  </svg>
);

export default UndoIcon;
